export default __webpack_public_path__ + "static/media/ykus.ee68a8e5.webp";